import styled from "@emotion/styled";
import {
  ConvertHTMLtoComponents,
  Grid,
  GridColumn,
  MediaQueries,
  Spacer,
  createCustomSpacing,
} from "@polestar/component-warehouse-react";

import { ContentHeader } from "../ContentHeader";

import { overrideElementMap } from "./overrideElementMap";

import { type Maybe } from "~/common/types";

export interface ContentWithHtmlProps {
  readonly contentSimple: string;
  readonly dictionary: Record<string, string>;
  readonly title: Maybe<string>;
  readonly version: Maybe<string>;
  readonly localizedDate: Maybe<string>;
  readonly changelogDescription: Maybe<string>;
  readonly handleDownloadPdf: () => void;
}

const ContentHeaderGridColumn = styled(GridColumn)`
  order: -1;
  ${MediaQueries.tablet} {
    order: 0;
  }
`;

const StyledGrid = styled(Grid)`
  grid-template-rows: auto auto;
  grid-row-gap: 0;
  ${MediaQueries.tablet} {
    grid-row-gap: 0;
  }
`;

const InPageNavigationGridColumn = styled(GridColumn)`
  height: 100%;
  grid-row-end: span 2;
`;

const ContentWithHtml = ({
  changelogDescription,
  contentSimple,
  dictionary,
  handleDownloadPdf,
  localizedDate,
  title,
  version,
}: ContentWithHtmlProps) => {
  return (
    <StyledGrid nested>
      <InPageNavigationGridColumn span={{ mobile: 0, tablet: 0, desktop: 4 }} />

      <ContentHeaderGridColumn
        span={{
          mobile: 4,
          tablet: 5,
          desktop: 8,
        }}
      >
        <ContentHeader
          title={title || ""}
          version={version || ""}
          date={localizedDate || ""}
          dictionary={dictionary}
          isChangelogAvailable={Boolean(changelogDescription)}
          onDownloadPdf={handleDownloadPdf}
        />
      </ContentHeaderGridColumn>

      <GridColumn
        id="printable"
        span={{
          mobile: 4,
          tablet: 5,
          desktop: 8,
        }}
      >
        <ConvertHTMLtoComponents overrideElementMap={overrideElementMap}>
          {contentSimple}
        </ConvertHTMLtoComponents>

        <Spacer spacing={createCustomSpacing(3.5)} />
      </GridColumn>
    </StyledGrid>
  );
};

export default ContentWithHtml;
